import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, TextField, Typography, Grid2,  Select, IconButton, Tooltip } from '@mui/material';
import useRouter from 'utils/useRouter';
import AddIcon from '@mui/icons-material/AddBox';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DataTable from '../../../../../../../../components/DataTable/DataTable';
import { SetFormState, GetOperatorProjects, ToggleAddEditUserDialog, ToggleAddPendingUsersDialog, DeletePendingUser } from '../../../../../../actions/UsersActions';

const schema = {
	firstname: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	lastname: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	email: {
		presence: { allowEmpty: false, message: 'is required' },
		email: true,
	},
	roleId: {
		presence: { allowEmpty: false, message: 'is required' },
	},
};

const useStyles = makeStyles((theme) => ({
	root: {},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1),
		},
	},
	submitButton: {
		marginTop: theme.spacing(2),
		width: '100%',
	},
}));

const AddPendingUsersForm = (props) => {
	const { className, roles, operators, projects, isEdit, ...rest } = props;

	const classes = useStyles();
	const router = useRouter();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.usersReducer.formState);
	const pendingUsers = useSelector((state) => state.usersReducer.pendingUsers);

	const _AddUser = (firstname, lastname, email) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				firstname,
				lastname,
				email
			}
		});

		// dispatch(ToggleAddPendingUsersDialog(false));
		dispatch(ToggleAddEditUserDialog(true));
	};

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = (deleteUserEmail) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				deleteUserEmail
			}
		});
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const _deleteUser = (userEmail) => {
		handleClickOpen(userEmail);
	};

	const handleDelete = () => {
		dispatch(DeletePendingUser(formState.values.deleteUserEmail));
		setOpen(false);
	};

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;
		return (
			<>
				<Tooltip title="Add">
					<IconButton
						style={{ color: 'green' }}
						color="green"
						edge="end"
						size="small"
						onClick={() => _AddUser(rowData[1], rowData[2], rowData[3])}
					>
						<AddIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Remove">
					<IconButton
						style={{ color: 'red' }}
						edge="end"
						size="small"
						onClick={() => _deleteUser(rowData[3])}
					>
						<CancelIcon />
					</IconButton>
				</Tooltip>
			</>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'firstname',
				label: 'First Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'lastname',
				label: 'Last Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'email',
				label: 'Email',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'date',
				label: 'Date',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'action',
				label: 'Actions',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: 'none',
		expandableRows: false, // Try Adding This
	});

	return (
		<div className={classes.fields}>
			<DataTable
				id="voiceDataTble"
				title=""
				data={pendingUsers}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="38em"
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{`Delete Pending User: ${formState.values.deleteUser}`}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Are you sure you want to delete this Pending User?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Close</Button>
					<Button onClick={handleDelete} autoFocus>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div>

	);
};

AddPendingUsersForm.propTypes = {
	className: PropTypes.string,
	roles: PropTypes.array,
	operators: PropTypes.array,
	projects: PropTypes.array,
	isEdit: PropTypes.bool,
};

export default AddPendingUsersForm;
